import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/internal/operators/map';
import { ErrorCode } from '../constants/error-code';
import { Observable } from 'rxjs';
import { Response } from 'src/app/shared/models/response.model';
import { analytics } from 'firebase';

const routes = {
  filter: '/enterprise/document-type/filter',
  filterChild: '/enterprise/document-type/sub/filter',
  serviceTypes: (id: any, isCreateContract?: any) => `/common/enterprise/service-type/${id}${routes.getServiceTypesParam(isCreateContract)}`,
  parentIds: (code: any) => `/enterprise/document-type/parent/${code}`,
  changeStatus: (id: string) => `/enterprise/document-type/change-status/${id}`,
  checkPermission: (id: string) => `/dc/document-type-enterprises/check-permission/${id}`,
  setAutoSign: (id: string) => `/enterprise/document-type/set-auto-sign/${id}`,
  setSignOTP: (id: string) => `/enterprise/document-type/change-otp-sign/${id}`,
  delete: (id: string) => `/enterprise/document-type/${id}`,
  getByEnterprise: (id: string) => `/enterprise/document-type/find-by-enterprise/${id}`,
  serviceType: (id: any) => `/enterprise/document-type/service-type/${id}`,
  getRealm: '/common/item-type/realm',
  systemGetAll: '/dc/document-type-enterprises/system-get-all',
  syncGetAll: '/dc/document-type-enterprises/get-all-sync',
  getListCategory: (id: string) => `/dc/document-type-enterprises/get-list-category/${id}`,
  downloadTemplate: '/dc/document-type-enterprises/copy-from-system',
  checkPermissionServiceType: (documentTypeId: string) => `/contract/check-permission-create-contract?documentTypeId=${documentTypeId}`,
  API_GET_BY_ID_LABOR_REPORT: () => `/contract-employment/document-type/details`,
  API_GET_PROPERTIES: () => `/contract-employment/document-type/details`,
  API_GET_PROPERTIES_FOR_UPLOAD_FILE: () => `/contract-employment/properties/get-all`,
  API_GET_DROP_DOWN_PROPERTIES: () => `/dc/template-files/get-all`,
  serviceTypesMoha: (id: any, isEmploymentContract?: any) => `/common/enterprise/service-type/${id}${isEmploymentContract ? `?isEmploymentContract=true` : ''}`,
  getServiceTypesParam: (isCreateContract: any) => {
    let params = isCreateContract ? `?isCreateContract=${isCreateContract}` : ''
    params += `${params.length ? '&' : '?'}isEmploymentContract=false`
    return params
  },
  serviceTypesAll: (id: any) => `/common/enterprise/service-type/${id}`,
};
@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {

  constructor(private apiService: ApiService) { }

  getByEnterprise(id: string) {
    return this.apiService.get(routes.getByEnterprise(id));
  }

  /**
   * Search list document type for enterprise
   */
  searchDocumentType(filter: any) {
    return this.apiService.post(routes.filter, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Search list child document type for enterprise
   */
  searchChildDocumentType(filter: any) {
    return this.apiService.post(routes.filterChild, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  /**
   * Change status
   */
  changeStatusDocumentType(id: string) {
    return this.apiService.get(routes.changeStatus(id));
  }

  checkPermission(id: string) {
    return this.apiService.get(routes.checkPermission(id)).pipe();
  }

  /**
   * Set auto sign
   */
  setAutoSignDocumentType(id: string) {
    return this.apiService.get(routes.setAutoSign(id));
  }

  /**
   * Set auto sign
   */
  setSignOTPDocumentType(id: string) {
    return this.apiService.get(routes.setSignOTP(id));
  }

  /**
   * Find by id
   */
  findById(id: string) {
    return this.apiService.get(routes.delete(id));
  }

  /**
   * Find by id (silent): man add-document tu quan ly loading, khong block UI toan trang
   */
  findByIdSilently(id: string) {
    return this.apiService.getSilently(routes.delete(id));
  }

  /**
   * Update document type for enterprise
   */
  updateDocumentType(documentTypeEnterprise: any, noCallBack: any, errCallback: any) {
    return this.addOrUpdateDocumentType('/enterprise/document-type/update/', documentTypeEnterprise, errCallback);
  }
  /**
   * Add Or Update DocumentType processing
   */
  addOrUpdateDocumentType(url: any, documentTypeEnterprise: any, errCallback: any) {
    return this.apiService.post(url, documentTypeEnterprise)
      .pipe(map(res => {
        this.handleUpdateOrEditDocument(errCallback, res, errCallback);
        return res;
      }
      ));
  }

  getServiceTypes(id: any, isCreateContract?: any): Observable<any>{
    return this.apiService.get(routes.serviceTypes(id, isCreateContract));
  }

  /**
   * silent: man add-document tu quan ly loading (isServiceTypesLoading), khong block UI toan trang
   */
  getServiceTypesSilently(id: any, isCreateContract?: any): Observable<any>{
    return this.apiService.getSilently(routes.serviceTypes(id, isCreateContract));
  }

  getServiceTypesAll(id: any): Observable<any>{
    return this.apiService.get(routes.serviceTypesAll(id)).pipe();
  }

  systemGetAll(body) {
    return this.apiService.post(routes.systemGetAll, body).pipe();
  }


  syncGetAll(body) {
    return this.apiService.post(routes.syncGetAll, body).pipe();
  }

  getRealm() {
    return this.apiService.get(routes.getRealm).pipe();
  }

  downloadTemplate(body) {
    return this.apiService.post(routes.downloadTemplate, body).pipe(map(res => {
      return res;
    }));
  }

  /**
   * Get ParentId list
   */
  getParentIds(code: any) {
    return this.apiService.get(routes.parentIds(code)).pipe();
  }

  /**
   * Create document type for enterprise
   */
  addDocumentType(documentTypeEnterprise: any, noCallBack: any, errCallback: any) {
    return this.addOrUpdateDocumentType('/enterprise/document-type', documentTypeEnterprise, errCallback);
  }

  /**
   * Get ServiceType from documentTypeId
   */
  getServiceTypeByDocumentTypeId(documentTypeId: any) {
    return this.apiService.get(routes.serviceType(documentTypeId)).pipe();
  }

  /**
   * Get ServiceType from documentTypeId (silent): khong block UI toan trang
   */
  getServiceTypeByDocumentTypeIdSilently(documentTypeId: any) {
    return this.apiService.getSilently(routes.serviceType(documentTypeId)).pipe();
  }

  getListCategory(documentTypeId: any) {
    return this.apiService.get(routes.getListCategory(documentTypeId)).pipe();
  }

  /**
   * Get documents type
   */
  getDocumentsType() {
    return this.apiService.get('/common/docs-type').pipe();
  }

  //Delete user apostrophe
  deleteUserApostrophe(id: any) {
    return this.apiService.get("/document/delete").pipe(map(res => {
      return res;
    }));
  }

  private handleUpdateOrEditDocument(errCallback: any, res, noCallBack: any) {
    if (errCallback && !res.success) {
      errCallback(res);
    } else if (res.code == ErrorCode.nameDuplicate) {
      noCallBack(res.code);
    }
  }

  checkPermissionServiceType(documentTypeId: string) {
    return this.apiService.get(routes.checkPermissionServiceType(documentTypeId)).pipe(map(res => {
      return res;
    }));
  }

  getLaborReportById(id: any): Observable<any>{
    return this.apiService.post(routes.API_GET_BY_ID_LABOR_REPORT(), {id: id}).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getInfoProperties(documentTypeEnterpriseId: any, isUploadFile: boolean = true): Observable<any> {
    if(isUploadFile){
      return this.apiService.post(routes.API_GET_PROPERTIES(), {documentTypeEnterpriseId: documentTypeEnterpriseId}).pipe(
        map((res) => {
          return res;
        })
      );
    }
    else{
      return this.apiService.get(routes.API_GET_PROPERTIES_FOR_UPLOAD_FILE()).pipe(
        map((res) => {
          return res;
        })
      );
    }
  }

  getDataDropDownOfPropertie(payload: any): Observable<Response<any>> {
    return this.apiService.get(routes.API_GET_DROP_DOWN_PROPERTIES(), payload).pipe(
      map((res) => {
        return res;
      })
    );
  }

  /**
   * Get ServiceType list
   */
   getServiceTypesMoha(id: any, isEmploymentContract?: any): Observable<any>{
    return this.apiService.get(routes.serviceTypesMoha(id, isEmploymentContract)).pipe();
  }
}
